angular.module('content.widgets.choiceDecisionWidget', [
  'content.widgets.ChoiceDecisionWidgetController'
])

/**
 * The choiceDecisionWidget provides a preview
 * of the choiceDecisionWidget item type
 *
 * @class ChoiceDecisionWidget
 * @constructor
 * @module content.widgets.choiceDecisionWidget
 * @example
 *   <choice-decision-widget
 *     model="form.model">
 *   </choice-decision-widget>
 */
.directive('choiceDecisionWidget', [
  '$state',
  function ($state) {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: function () {
        if ($state.params.widgetMode === 'edit' || $state.params.stateMode === 'edit') {
          return 'content/source/content/widgets/choiceDecisionWidget/'
            + 'choice-decision-widget-edit.html';
        }
        return 'content/source/content/widgets/choiceDecisionWidget/choice-decision-widget.html';
      },
      controller: 'ChoiceDecisionWidgetController'
    };
  }
]);
